import { injectable } from 'inversify';

type Listener = () => void;

/**
 * Позволяет странице отрисовать баннер деградации у себя (например, в сдвинутой области рядом с Drawer)
 * вместо баннера layout
 */
@injectable()
export class DegradationBannerSlotService {
  private embeddedCount = 0;

  private listeners = new Set<Listener>();

  /**
   * Зарегистрировать баннер, отрисованный внутри страницы
   * @returns Функция отмены регистрации
   */
  register = () => {
    this.setEmbeddedCount(this.embeddedCount + 1);

    return () => {
      this.setEmbeddedCount(this.embeddedCount - 1);
    };
  };

  /**
   * Проверить, отрисован ли баннер внутри страницы
   * @returns `true`, если хотя бы одна страница отрисовала баннер у себя
   */
  isEmbedded = () => this.embeddedCount > 0;

  /**
   * Подписаться на изменение признака
   * @param listener - Функция, вызываемая при изменении признака
   * @returns Функция отписки
   */
  subscribe = (listener: Listener) => {
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  };

  private setEmbeddedCount(count: number) {
    this.embeddedCount = count;
    this.listeners.forEach((listener) => listener());
  }
}
